module.exports = __webpack_public_path__ + "img/10P.20b4f119.jpg";